import React, { useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  FileInput,
  ImageField,
  useCreate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { htmlToBlocks } from '../../../helpers/htmlUtils';
import { uploadImage } from '../../../config/services/strapi/strapi';

function CasosExitoCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmit = async(data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      if (!token) {
        notify('No se encontró el token de autenticación', { type: 'error' });
        return;
      }

      const payload = {
        nombre: data.nombre,
        portada: await uploadImage(data.portada.rawFile, token),
        banner: await uploadImage(data.banner.rawFile, token),
        portada_carousel: data.portada_carousel ? await uploadImage(data.portada_carousel.rawFile, token) : null,
        rubro: data.rubro,
        region: data.region,
        provincia: data.provincia,
        comuna: data.comuna,
        impactos: htmlToBlocks(data.impactos),
        descripcion: htmlToBlocks(data.descripcion),
        imagenes: await Promise.all(data.imagenes.map((file: any) => {
          return uploadImage(file.rawFile, token);
        })),
        fragmento_url: data.fragmento_url,
        slug: data.slug,
        destacado: data.destacado,
      };

      create(
        'casos-exitos',
        { data: payload },
        {
          onSuccess: () => {
            notify('Elemento creado');
            redirect('list', 'casos-exitos');
          },
          onError: (error: any) => {
            notify(`Error: ${error.message}`, { type: 'error' });
          },
        }
      );
    }
    catch(error) {
      notify('Error al crear el caso de éxito', { type: 'error' });
      return;
    }
  };

  useEffect(() => {
    document.title = 'Crear Caso de Éxito';
  }, []);

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="nombre" validate={[required()]} />
        <FileInput
          source='portada'
          label='Imagen de Portada'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
        <FileInput
          source='banner'
          label='Imagen de Banner'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
        <FileInput
          source='portada_carousel'
          label='Imagen de Portada Carousel'
        >
          <ImageField source="src" />
        </FileInput>
        <TextInput source="rubro" />
        <TextInput source="region" />
        <TextInput source="provincia" />
        <TextInput source="comuna" />
        <RichTextInput source="impactos" />
        <RichTextInput source="descripcion" />
        <FileInput
          source='imagenes'
          label='Imágenes Adicionales'
          multiple={true}
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
        <TextInput source="fragmento_url" label='URL del Fragmento' />
        <TextInput source="slug" validate={[required()]} />
        <BooleanInput source="destacado" />
      </SimpleForm>
    </Create>
  )
}

export default CasosExitoCreate;